window.addEventListener('OpusCartChange',(event)=>{
const data = event.detail;
  const num = data.item_count;
  const eleCount = document.querySelector('.header__cart-count');
  if(eleCount){
    eleCount.textContent =data.item_count
  }else{
    const textIner =`  <div id="cart-icon-bubble"><div class="header__cart-count absolute bg-theme-text text-theme-bg text-center">0</div><div class="cart-count-bubble"><span aria-hidden="true">0</span><span class="visually-hidden">2 item</span></div></div>`;
    document.querySelector('#cart-icon-bubble').innerHTML = textIner;
  }
})


window.addEventListener('OpusCartChange',(event)=>{
  const data = event.detail;
  const findSelectEl = document.querySelector('.opus-price-ct-container');
  if(findSelectEl){
    findSelectEl.remove();
  }
  const isPriceDiscount = data.original_total_price - data.total_price >0;
  document.querySelector('.cd-checkout-section-container').insertAdjacentHTML("beforebegin",`<div class="opus-price-ct-container" style="display: flex; padding-top: 15px; justify-content: space-between; font-size: 16px; font-weight: bold; width: 100%; gap: 20px;"><span style="flex-shrink: 0; color: white; margin-right: 2.5vw"> <strong>Total:</strong> </span> <span style="text-align: right; flex-grow: 1; color: white;">${data.money} <span style="font-size: 14px; color: grey; text-decoration: line-through; font-weight: 500; margin-left: 5px;"> ${isPriceDiscount? data.oPriceMoney : ''} </span> </span> </div>`
  );
})

